import { render, staticRenderFns } from "./BodyCare.vue?vue&type=template&id=1c782f40&"
import script from "./BodyCare.vue?vue&type=script&lang=js&"
export * from "./BodyCare.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports